import axios from 'axios'
import router from '../router'

var qs = require('qs');

function apiAxios(method, url, params, callback, needUserInfo = false) {
  let last_location_href = localStorage.getItem('last_location_href');
  if (!last_location_href) {
    last_location_href = window.location.href
  }
  let access_token = localStorage.getItem('access_token')
  if (needUserInfo && (!access_token || access_token == '' || access_token == undefined)) {
    //跳去授权登录页面 return
    localStorage.setItem('last_location_href', last_location_href);
    // console.log('进来前的页面路径1', last_location_href)
    router.push({
      path: '/login'
    })
    return
  }

  axios({
    method: method,
    url: url + '?access-token=' + access_token,
    data: method === 'POST' || method === 'PUT' ? qs.stringify(params) : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    baseURL: process.env.API_HOST,
  }).then(function(res) {
    if (res.data.code == 0) {
      if (needUserInfo && res.data.status == 401) {
        //先清空token,再跳转授权
        localStorage.setItem('last_location_href', last_location_href);
        localStorage.removeItem('access_token')
        router.push({
          path: '/login'
        })
        return
      }
    } else if (res.data.code == 401) {
      //跳去授权登录页面
      localStorage.setItem('last_location_href', last_location_href);
      localStorage.removeItem('access_token')
      router.push({
        path: '/login'
      })
      return
    }else if (res.data.code == 402) {
      //跳去实名认证页面
      router.push({
        path: '/editinfo'
      })
      return
    } else if (res.data.code == 0 && res.status == 401) {
      //跳去授权登录页面
      localStorage.setItem('last_location_href', last_location_href);
      localStorage.removeItem('access_token')
      router.push({
        path: '/login'
      })
      return
    }
    return typeof callback == 'function' && callback(res.data)
  }, function(error) {
    // console.log('response', error.response);
    var res = error.response
    if (res.data.code == 0) {
      if (needUserInfo && res.data.status == 401) {
        //先清空token,再跳转授权
        localStorage.setItem('last_location_href', last_location_href);
        localStorage.removeItem('access_token')
        router.push({
          path: '/login'
        })
        return
      }
    } else if (res.data.code == 401) {
      //跳去授权登录页面
      localStorage.setItem('last_location_href', last_location_href);
      localStorage.removeItem('access_token')
      router.push({
        path: '/login'
      })
      return
    }else if (res.data.code == 402) {
      //跳去实名认证页面
      router.push({
        path: '/editinfo'
      })
      return
    }
  })
}

var apiAjax = {
  get: function(url, params, callback, needUserInfo = false) {
    return apiAxios('GET', url, params, callback, needUserInfo)
  },
  post: function(url, params, callback, needUserInfo = false) {
    return apiAxios('POST', url, params, callback, needUserInfo, )
  },
  put: function(url, params, callback, needUserInfo = true) {
    return apiAxios('PUT', url, params, callback, needUserInfo)
  },
  delete: function(url, params, callback, needUserInfo = true) {
    return apiAxios('DELETE', url, params, callback, needUserInfo)
  }
}

export default apiAjax



// WEBPACK FOOTER //
// ./src/api/http.js